import React from 'react';
import Home from '../pages/Home';
import ServicesPage from '../pages/ServicesPage';
import TeamPage from '../pages/TeamPage';
import ContactPage from '../pages/ContactPage';
import CareersPage from '../pages/CareersPage';
import AboutPage from '../pages/AboutPage';
import BpoServicesPage from '../pages/BpoServicesPage';
import LogoDesignPage from '../pages/LogoDesignPage';
import EcommerceWebDevPage from '../pages/EcommerceWebDevPage';
import WebDesignPage from '../pages/WebDesignPage';
import WebDevelopmentPage from '../pages/WebDevelopmentPage';
import DigitalMarketingPage from '../pages/DigitalMarketingPage';
import ItServicesPage from '../pages/ItServicesPage';
import SeoServicesPage from '../pages/SeoServicesPage';
import SocialMediaMarketingPage from '../pages/SocialMediaMarketingPage';
import TermsPage from '../pages/TermsPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import JobApplicationPage from '../pages/JobApplicationPage';
import NotFoundPage from '../pages/NotFoundPage';

function AppRoutes({ currentView, setView }) {
  switch (currentView) {
    case 'job-application':
      return <JobApplicationPage />;
    case 'privacy-policy':
      return <PrivacyPolicyPage />;
    case 'terms-and-conditions':
      return <TermsPage />;
    case 'social-media-marketing':
      return <SocialMediaMarketingPage />;
    case 'seo-services':
      return <SeoServicesPage />;
    case 'web-development':
      return <WebDevelopmentPage />;
    case 'it-services':
      return <ItServicesPage setView={setView} />;
    case 'digital-marketing':
      return <DigitalMarketingPage />;
    case 'ecommerce-web-development':
      return <EcommerceWebDevPage />;
    case 'web-design':
      return <WebDesignPage />;
    case 'logo-design':
      return <LogoDesignPage setView={setView} />;
    case 'bpo-services':
      return <BpoServicesPage />;
    case 'services':
      return <ServicesPage setView={setView} />;
    case 'team':
      return <TeamPage />;
    case 'contact':
      return <ContactPage />;
    case 'careers':
      return <CareersPage setView={setView} />;
    case 'about':
      return <AboutPage setView={setView} />;
    case '404':
      return <NotFoundPage setView={setView} />;
    case 'home':
      return <Home setView={setView} />;
    default:
      return <NotFoundPage setView={setView} />;
  }
}

export default AppRoutes;
